// 该文件由 OneAPI 自动生成，请勿手动修改！
import { API_v2 } from '@/services/config';
import { request } from '@umijs/max';

export async function login(body: { username: string; password: string }, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.login, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/**
 * 获取用户组列表( table )
 * @param params
 * @param options
 */
export async function getAdminGroupList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    query_all?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getAdminGroupList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 添加用户组
 * @param data
 * @param options
 */
export async function addAdminGroup(
  data: {
    page?: number;
    pageSize?: number;
    field_name: string;
    ids: number[];
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addAdminGroup, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 添加用户组
 * @param data
 * @param options
 */
export async function editAdminGroup(
  data: {
    page?: number;
    pageSize?: number;
    field_name?: string;
    id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.editAdminGroup, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 删除用户组
 * @param data
 * @param options
 */
export async function delAdminGroup(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delAdminGroup, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 获取已经在组中的用户回显
 * @param params
 * @param options
 */
export async function listGroupUsers(
  params: {
    filed_name?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.listGroupUsers, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 获取用户列表( table )
 * @param params
 * @param options
 */
export async function getAdminList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getAdminList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 修改用户信息
 * @param data
 * @param options
 */
export async function editAdmin(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    admin_id?: number;
    field_name?: string;
    username?: string;
    tel?: string;
    group_ids?: number[];
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.editAdmin, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 新增用户
 * @param data
 * @param options
 */
export async function addAdmin(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    id?: number;
    group_ids?: number[];
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addAdmin, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

//员工列表增删改查接口
/**
 * 获取员工列表( table )
 * @param params
 * @param options
 */
export async function getCompanyPersonnelList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getCompanyPersonnelList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 修改员工信息
 * @param data
 * @param options
 */
export async function editCompanyPersonnel(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_personnel_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.editCompanyPersonnel, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 添加员工
 * @param data
 * @param options
 */
export async function addCompanyPersonnel(
  data: {
    page?: number;
    pageSize?: number;
    field_name?: string;
    ids?: number[];
    company_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addCompanyPersonnel, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 删除员工
 * @param data
 * @param options
 */
export async function delCompanyPersonnel(
  data: {
    page?: number;
    pageSize?: number;
    field_name?: string;
    company_personnel_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delCompanyPersonnel, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 修改个人信息
 * @param data
 * @param options
 */
export async function editAdminSelf(data: {}, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editAdminSelf, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 移动公司员工
 * @param data
 * @param options
 */
export async function moveCompanyPersonnel(data: {}, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.moveCompanyPersonnel, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 工种配置列表( table )
 * @param params
 * @param options
 */
export async function getWageCompanyList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    query_all?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getWageCompanyList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 新增工种
 * @param data
 * @param options
 */
export async function addWageCompany(
  data: {
    page?: number;
    pageSize?: number;
    company_id?: string;
    job_type?: string;
    daily_wage?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addWageCompany, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 编辑工种
 * @param data
 * @param options
 */
export async function editWageCompany(data: {}, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editWageCompany, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除工种
 * @param data
 * @param options
 */
export async function delWageCompany(
  data: {
    page?: number;
    pageSize?: number;
    field_name?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delWageCompany, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 个人请假列表( table )
 * @param params
 * @param options
 */
export async function getSelfLeaveRequestsList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getSelfLeaveRequestsList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 请假申请列表( table )
 * @param params
 * @param options
 */
export async function getLeaveRequestsList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getLeaveRequestsList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 新增请假申请
 * @param data
 * @param options
 */
export async function addLeaveRequests(
  data: {
    process_id: number;
    platform_id: any;
    id: any;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addLeaveRequests, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 审批请假申请
 * @param data
 * @param options
 */
export async function approveLeaveRequests(
  data: {
    page?: number;
    pageSize?: number;
    field_name: string;
    ids: number[];
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.approveLeaveRequests, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 取消请假申请
 * @param data
 * @param options
 */
export async function cancelLeaveRequests(
  data: {
    page?: number;
    pageSize?: number;
    field_name: string;
    ids: number[];
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.cancelLeaveRequests, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 获取个人银行账户列表( table )
 * @param params
 * @param options
 */
export async function getMyBankAccountsList(
  params: {
    page?: number;
    pageSize?: number;
    company_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getMyBankAccountsList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}

/**
 * 新增个人银行账户
 * @param data
 * @param options
 */
export async function addMyBankAccounts(data: {}, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.addMyBankAccounts, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 修改个人银行账户
 * @param data
 * @param options
 */
export async function editMyBankAccounts(data: {}, options?: { [key: string]: any }) {
  // 执行实际的 API 请求
  return request(API_v2.editMyBankAccounts, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 删除个人银行账户
 * @param data
 * @param options
 */
export async function delMyBankAccounts(
  data: {
    account_id?: any | string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delMyBankAccounts, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
